/**
 * Helpers for comparing request URLs against the addresses configured in
 * `environment.*.ts`. Shared so every interceptor agrees on what "this URL
 * belongs to that service" means.
 */

export function trimTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '');
}

/**
 * Whether `url` addresses `base` or something below it.
 *
 * Segment-aware on purpose: a plain `startsWith` would treat `/apidocs` as part
 * of the `/api` service and, in `authTokenInterceptor`, leak the bearer token to
 * it.
 *
 * `base` is expected to have gone through {@link trimTrailingSlash}. An empty
 * base matches nothing rather than everything.
 */
export function isUnderBase(url: string, base: string): boolean {
  return base !== '' && (url === base || url.startsWith(`${base}/`));
}
